import React from 'react';
import PropTypes from 'prop-types';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';
import Modal from '@components/application/modal';
import FinanceDrawer from './financeDrawer';
import FinanceTypes from './financeTypes';
import DealBuilderButton from '@javascript/vehicle_product/header/dealBuilderButton';
import LiveChatButton from '@javascript/vehicle_product/header/liveChatButton';

const Finance = ({
  contract_hire,
  personal_contract_hire,
  dealTotal,
  hp,
  hpCalculatorChanged,
  isDepositSaved,
  isEligibleForDealBuilder,
  loading,
  pcp,
  pcpCalculatorChanged,
  pcpError,
  selectedFinance,
  setSelectedFinance,
  stockReference,
  submitFinanceEnquiry,
}) => {
  const openModal = () =>
    EventEmitter.emit(EVENT_TYPES.openModal, 'finance-type-drawer');

  const closeModal = () => EventEmitter.emit(EVENT_TYPES.closeModal);

  const renderToggle = () => {
    if (hp && pcp) {
      return (
        <div className="js-off--hide ac-finance__toggle-container">
          <p className="ch-h1">Choose your finance</p>
          <p className="ch-fs--3 ch-color--grey-6">
            These are estimates and could change if you decide to apply for
            finance.{' '}
            <a href="https://www.arnoldclark.com/car-finance">
              Car finance explained.
            </a>
          </p>
          <div className="ch-mb--2 ac-finance__toggle">
            <span>
              <input
                checked={selectedFinance === 'pcp'}
                className="ch-reader"
                id="pcp"
                name="productpage_switcher"
                onChange={setSelectedFinance}
                type="radio"
                value="pcp"
              />
              <label htmlFor="pcp">PCP</label>
            </span>
            <span>
              <input
                checked={selectedFinance === 'hp'}
                className="ch-reader"
                id="hp"
                name="productpage_switcher"
                onChange={setSelectedFinance}
                type="radio"
                value="hp"
              />
              <label htmlFor="hp">HP</label>
            </span>
          </div>
        </div>
      );
    }
  };

  const renderFooter = () => {
    return (
      <p className="ch-fs--1 ch-mt--3">
        Arnold Clark Automobiles Limited is authorised and regulated by the
        Financial Conduct Authority (
        <a
          href="https://register.fca.org.uk/s/firm?id=001b000000MfWTWAA3"
          id="fca-registration-link"
          rel="nofollow noreferrer"
          target="_blank"
          title="View Firm Registration on FCA Website"
        >
          308092
        </a>
        ) for general insurance and consumer credit purposes. We act as a credit
        broker sourcing credit to assist with your purchase from a carefully
        selected panel of lenders. Lenders will pay us a fee for these
        introductions (
        <a
          href="/terms-of-use/panel-of-lenders"
          id="finance-disclaimer-link"
          rel="nofollow"
          target="_blank"
          title="Opens Panel of Lenders in a new tab"
        >
          click&nbsp;here
        </a>{' '}
        for details including our panel of lenders and disclosure statement).
        Offers subject to status, terms and conditions.
      </p>
    );
  };

  const financeProps = {
    pcp: pcp,
    hp: hp,
    contract_hire: contract_hire,
    personal_contract_hire: personal_contract_hire,
  };

  return (
    <>
      <div className="ac-finance" id="finance">
        <div className="ch-container">
          {renderToggle()}
          <div className="ch-display--flex ch-flex-flow--column-nowrap md:ch-flex-flow--row-nowrap">
            <div className="md:ch-width--8">
              <FinanceTypes
                financeType={selectedFinance}
                openModal={openModal}
                {...financeProps[selectedFinance]}
                dealTotal={dealTotal}
                hpCalculatorChanged={hpCalculatorChanged}
                isDepositSaved={isDepositSaved}
                loading={loading}
                pcpCalculatorChanged={pcpCalculatorChanged}
                pcpError={pcpError}
              />
            </div>
            <div className="md:ch-width--4 md:ch-ml--2">
              <div className="ch-card js-off--hide">
                <div className="ch-card__content ch-card__content--grey">
                  <h3 className="ch-h2 ch-mb--1">Next steps</h3>
                  <p className="ch-text--left ch-color--grey-6 ch-fs--2">
                    Create and choose a deal that works for you in minutes.
                  </p>
                  {isEligibleForDealBuilder && (
                    <>
                      <DealBuilderButton
                        buttonLabel="Build a personalised deal"
                        stockReference={stockReference}
                        trackingLabel="Opened deal stacker (finance calc)"
                      />
                      <hr className="ch-mv--2" />
                    </>
                  )}
                  <div className="ch-display--flex ch-flex-flow--column-nowrap ch-align-items--stretch">
                    <button
                      className="ch-btn ch-btn ch-btn--secondary ch-mb--2 ch-width--12"
                      data-event-name="Product page: Enquire Now CTA"
                      data-gtm-track="click_cta"
                      data-gtm-track-label="Enquire now (finance)"
                      data-insight-event="conversion"
                      onClick={submitFinanceEnquiry}
                      type="button"
                    >
                      Send an enquiry
                    </button>
                    <LiveChatButton isFinanceSection />
                  </div>
                </div>
              </div>
              {renderFooter()}
            </div>
          </div>
        </div>
      </div>
      <Modal hideClose id="finance-type-drawer">
        <FinanceDrawer closeModal={closeModal} financeType={selectedFinance} />
      </Modal>
    </>
  );
};

export default Finance;

Finance.propTypes = {
  contract_hire: PropTypes.object,
  dealTotal: PropTypes.number,
  hp: PropTypes.object,
  hpCalculatorChanged: PropTypes.func,
  isDepositSaved: PropTypes.bool,
  isEligibleForDealBuilder: PropTypes.bool,
  loading: PropTypes.bool,
  pcp: PropTypes.object,
  pcpCalculatorChanged: PropTypes.func,
  pcpError: PropTypes.string,
  personal_contract_hire: PropTypes.object,
  selectedFinance: PropTypes.string,
  setSelectedFinance: PropTypes.func,
  stockReference: PropTypes.string,
  submitFinanceEnquiry: PropTypes.func,
};
